var DB_Product_HowItWork = {
    current_image:0,
    timeout_transition:0,
    init:function(){
        window.addEventListener("scroll", function(){
            DB_Product_HowItWork.scroll();
        });
        DB_Product_HowItWork.scroll();
    },
    scroll:function(){
        /*
        var _pos_scroll = window.scrollY + (window.innerHeight /2);
        */
        var current_item = 0;

        if(window.innerWidth > 1200){
            var _screen_limit = window.innerHeight * 0.5;
        }else if(window.innerWidth > 768){
            var _screen_limit = window.innerHeight * 0.7;
        }else{
            var _screen_limit = window.innerHeight * 0.6;
        }
        
        document.querySelectorAll(".DB-card-content .card-content__list-item").forEach(function(item, i){
            /*console.log("TEST SCROLL HOW : " + _pos_scroll +" // " + item.offsetTop + " //// " + item.getBoundingClientRect().top);
            if(_pos_scroll > item.offsetTop){
                current_item = i;
            }
            */
           if(item.getBoundingClientRect().top <_screen_limit){
            current_item = i;
           }
        })
        
        if(current_item != DB_Product_HowItWork.current_image){
            DB_Product_HowItWork.change_image(current_item);
        }
    },
    change_image:function(id){
        console.log("HOW IT WORK : CHANGE IMAGE " + id);

        document.querySelector(".DB-card-content .images-container").classList.add("transitioning");

        document.querySelectorAll(".DB-card-content .images-container .image").forEach(function(item, i){
            item.classList.remove("from-selected");
            item.classList.remove("from-prev");
            item.classList.remove("from-next");
            
            if(i == id){
                if(item.classList.contains("prev")){
                    item.classList.add("from-prev");
                }
                if(item.classList.contains("next")){
                    item.classList.add("from-next");
                }

                item.classList.add("selected");
                item.classList.remove("prev");
                item.classList.remove("next");
            }else {
                if(item.classList.contains("selected")){
                    item.classList.add("from-selected");
                }
                
                item.classList.remove("selected");

                if (i < id){
                    item.classList.add("prev");
                    item.classList.remove("next");
                }else{
                    item.classList.remove("prev");
                    item.classList.add("next");
                }
            }
        });
        DB_Product_HowItWork.current_image = id;

        DB_Product_HowItWork.timeout_transition = setTimeout(function(){
            document.querySelector(".DB-card-content .images-container").classList.remove("transitioning");
        }, 200);
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".DB-card-content").length > 0){
        DB_Product_HowItWork.init();
    }
})